var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0666 13.4585C23.56 13.4585 22.2133 14.1918 21.3733 15.3118C20.5333 14.1918 19.1867 13.4585 17.68 13.4585C15.1333 13.4585 13.0667 15.5385 13.0667 18.0985C13.0667 19.0852 13.2266 20.0052 13.4933 20.8452C14.8 24.9918 18.8533 27.4852 20.8533 28.1652C21.1333 28.2585 21.6 28.2585 21.88 28.1652C23.88 27.4852 27.9333 25.0052 29.24 20.8452C29.52 19.9918 29.6667 19.0852 29.6667 18.0985C29.68 15.5385 27.6133 13.4585 25.0666 13.4585Z",
    fill: "#14904A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6666 11.3651C27.6666 11.6718 27.36 11.8718 27.0666 11.7918C25.2666 11.3251 23.2933 11.7118 21.8 12.7784C21.5066 12.9918 21.1066 12.9918 20.8266 12.7784C19.7733 12.0051 18.4933 11.5784 17.1466 11.5784C13.7066 11.5784 10.9066 14.3918 10.9066 17.8584C10.9066 21.6184 12.7066 24.4317 14.52 26.3117C14.6133 26.4051 14.5333 26.5651 14.4133 26.5118C10.7733 25.2718 2.66663 20.1251 2.66663 11.3651C2.66663 7.49842 5.77329 4.37842 9.61329 4.37842C11.8933 4.37842 13.9066 5.47175 15.1733 7.16508C16.4533 5.47175 18.4666 4.37842 20.7333 4.37842C24.56 4.37842 27.6666 7.49842 27.6666 11.3651Z",
    fill: "#14904A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovely);
export default __webpack_public_path__ + "static/media/lovely.a26e8e386447ffe0c5eb06048d06f7ba.svg";
export { ForwardRef as ReactComponent };